<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  @let store = offshoreOperationalStore;
  @let vm = offshoreReportStore.vm();
  <h1 class="mb-4 self-center text-xl">Voyage Details</h1>

  <nsp-text-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'voyageNumber')"
    id="voyageNumber"
    name="voyageNumber"
    label="Voyage Number"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'voyageNumber')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'voyageNumber')"
    [value]="store.voyageDetails?.()?.voyageNumber?.value"
    [ngModel]="store.voyageDetails?.()?.voyageNumber?.value"
  />
  <nsp-select-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'voyageFrom')"
    id="voyageFrom"
    name="voyageFrom"
    label="Voyage From"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'voyageFrom')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'voyageFrom')"
    [options]="portOptions()"
    [value]="store.voyageDetails?.()?.voyageFrom?.value"
    [ngModel]="store.voyageDetails?.()?.voyageFrom?.value"
    [virtualScroll]="true"
    [virtualScrollItemSize]="20"
    [filter]="true"
  >
  </nsp-select-input>

  <nsp-select-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'voyageTo')"
    id="voyageTo"
    name="voyageTo"
    label="Voyage To"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'voyageTo')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'voyageTo')"
    [options]="portOptions()"
    [value]="store.voyageDetails?.()?.voyageTo?.value"
    [ngModel]="store.voyageDetails?.()?.voyageTo?.value"
    [virtualScroll]="true"
    [virtualScrollItemSize]="20"
    [filter]="true"
  ></nsp-select-input>

  <nsp-calendar-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'eta')"
    id="eta"
    name="eta"
    label="ETA"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'eta')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'eta')"
    [value]="store.voyageDetails?.()?.eta?.value"
    [ngModel]="store.voyageDetails?.()?.eta?.value"
  />

  <nsp-select-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'etaTimezone')"
    id="etaTimezone"
    name="etaTimezone"
    label="ETA Timezone"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'etaTimezone')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'etaTimezone')"
    [options]="timezoneOptions"
    [value]="store.voyageDetails?.()?.etaTimezone?.value"
    [ngModel]="store.voyageDetails?.()?.etaTimezone?.value"
  ></nsp-select-input>
</form>
